<template>
  <!-- 渠道提成流程详情 -->
  <div class="bid-follow-process-detail">
    <div class="title">
      渠道提成审批进度（ {{details.Code}} ）
    </div>
    <div v-if="JSON.stringify(details) != '{}'">
      <sub-title title="渠道信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              提成类型：
            </div>
            <div class="item-right">
              {{details.ChannelType|commissionTypeFilter}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              提成对接人：
            </div>
            <div class="item-right">
              {{details.DockingPeople}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              提成比例：
            </div>
            <div class="item-right">
              {{Number((details.Rate*100).toFixed(2))}} %
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              手机号码：
            </div>
            <div class="item-right">
              {{details.Phone}}
            </div>
          </div>
          <div class="details-box-item" style="width:66.66%">
            <div class="item-left">
              事由：
            </div>
            <div class="item-right">
              {{details.Reason}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="item-left">
            有效期：
          </div>
          <div class="item-right">
            {{$common.timesToTime(details.Deadline)}}
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <flow-chart :details="processData" :selTab="type" :TemplateID="TemplateID" @close="$emit('refresh')" v-if="JSON.stringify(details)!='{}'" />
    </div>
  </div>
</template>
<script>
import { WorkflowQuery } from '@/http/api'
var that;
export default {
  name: 'ChannelCommission',
  props: {
    ID: {       // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    TemplateID: {    // 流程ID
      type: Number,
      default: null
    }
  },
  data() {
    return {
      orderTeamTypes: this.$orderTeamTypes,
      processData: {},
      details: {}
    }
  },
  watch: {
    ID: {
      handler(val, oldVal) {
        this.getDetails();
      },
      immediate: true
    }
  },
  created() {
    that = this;
  },
  filters: {
    commissionTypeFilter(val) {
      const find = that.orderTeamTypes.find(item => item.Name === val);
      return (find && find.Title) || ""
    }
  },
  methods: {
    getDetails() {
      this.$emit('loading', true)
      WorkflowQuery({ workflowId: this.ID, templateId: this.TemplateID }, 'Get').then(res => {
        if (!!res && JSON.stringify(res) != "{}") {
          this.details = res.ChannelCommissionConfig;
          this.processData = res;
        };
        this.$emit('loading', false)
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import "./details.less";
</style>